import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { PropTypes } from 'prop-types';
import { LoadingButton } from '@mui/lab';

ConfirmationDialog.propTypes = {
  openDialog: PropTypes.bool,
  handleDialog: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  confirmLabel: PropTypes.string,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func,
};

ConfirmationDialog.defaultProps = {
  title: 'Are you sure?',
  description: '',
  confirmLabel: 'Delete',
  loading: false,
  onConfirm: null,
};

/**
 * Generic confirm-before-deleting dialog.
 *
 * It used to dispatch the categories package's delete action itself, whoever
 * rendered it — so the branches, suppliers and subcategories pages were each
 * wired to delete an *asset category* using their own row's id. That was
 * harmless only because the route it called did not exist; once the category
 * delete endpoint started working it would have destroyed the wrong record.
 *
 * The caller now supplies `onConfirm`. Without one the dialog says so and the
 * confirm button stays disabled, rather than deleting something unrelated.
 */
export default function ConfirmationDialog({
  openDialog,
  handleDialog,
  title,
  description,
  confirmLabel,
  loading,
  onConfirm,
}) {
  return (
    <Dialog open={openDialog} onClose={handleDialog} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {description ? <DialogContentText sx={{ mb: 2 }}>{description}</DialogContentText> : null}
        {!onConfirm && (
          <Alert severity="warning">
            Deleting is not available here yet — this record type has no delete endpoint.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button size="small" variant="outlined" onClick={handleDialog}>
          Cancel
        </Button>
        <LoadingButton
          size="small"
          color="error"
          variant="contained"
          loading={loading}
          disabled={!onConfirm}
          onClick={onConfirm ?? undefined}
        >
          {confirmLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
